export default __webpack_public_path__ + "static/media/MyLogo.d58c92fb.gif";